import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const RulesSection = ({ accepted, onAcceptChange, error }) => {
  const rules = [
    'این سرویس برای ارسال پیام‌های احساسی و محترمانه طراحی شده است',
    'هویت فرستنده برای گیرنده ناشناس باقی می‌ماند',
    'به هر شماره تلفن بیش از سه پیام در روز ارسال نمی‌شود',
    'پس از پرداخت، پیام به صورت خودکار ارسال خواهد شد',
  ];

  const handleChange = (e) => {
    const isChecked = e?.target?.checked || false;
    if (typeof onAcceptChange === 'function') {
      onAcceptChange(isChecked);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8">
      <div className="flex items-center gap-3 mb-4 md:mb-6 pb-4 border-b border-purple-100">
        <div className="bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl p-2">
          <Icon name="FileText" size={20} color="#ffffff" />
        </div>
        <h2 className="text-lg md:text-xl font-bold text-gray-800">
          قوانین و مقررات
        </h2>
      </div>
      <div className="space-y-3 md:space-y-4 mb-4 md:mb-6">
        {rules?.map((rule, index) => (
          <div key={index} className="flex items-start gap-3">
            <div className="mt-1 flex-shrink-0">
              <Icon name="Check" size={18} color="#a855f7" />
            </div>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              {rule}
            </p>
          </div>
        ))}
      </div>
      <div className="pt-4 md:pt-6 border-t border-gray-100">
        <Checkbox
          label="تمامی قوانین و مقررات را مطالعه کرده و می‌پذیرم"
          description="برای ادامه باید قوانین را بپذیرید"
          required
          checked={accepted}
          onChange={handleChange}
          error={error}
          size="default"
        />
      </div>
    </div>
  );
};

export default RulesSection;
